import { type ReactNode } from 'react';
import type { Payment } from '../types';
import { formatUSD } from '../utils/payment-formatters';
import { PaymentCardHeader } from './payment-card-header';

export function PaymentCardOverlay({
  payment: p,
}: {
  payment: Payment;
}): ReactNode {
  return (
    <div className="w-[260px] rounded-md border border-brand-red/30 bg-surface-elevated p-sm shadow-lg shadow-black/40">
      <PaymentCardHeader payment={p} />
      <div className="mt-sm flex items-baseline gap-sm">
        <span className="text-sm font-bold text-text-primary">
          {formatUSD(p.total_earnings)}
        </span>
      </div>
      <p className="mt-1 text-[10px] text-text-secondary">
        {p.lead_count} creadores
      </p>
    </div>
  );
}
